import { makeStyles } from "@material-ui/core/styles";
import { isiOS, isWeb } from "../../utils/utility";
import { fontClasses } from "../../fontStyles";

const useMobileStyles = makeStyles((theme) => ({
  hvDashboardErrorContainer: {
    width: 'auto',
    height: isWeb() ? 'calc(100vh - 32vh)' : isiOS() ? 'calc(100vh - 64px - env(safe-area-inset-top))' : 'calc(100vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflowY: 'auto',
    padding: '20px',
  },
  descContainer: {
    display:'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    gap: '24px',
    width: isWeb() ? '500px' : '250px'
  },
  errorDesc: {
    ...fontClasses.body1,
    fontSize: isWeb() ? '16px !important' : '12px !important',
    textAlign: 'center',
    color: theme.palette.primary.heading,
  },
  tryAgainBtn: {
    marginTop: '48px',
    cursor: 'pointer',
    border: '1px solid #01B5DE',
    width: '100%',
    textAlign: 'center',
    padding: '5px',
    fontSize: '16px',
    lineHeight: '20px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    color: '#01B5DE'
  }
}));

export { useMobileStyles };
